<template>
  <div class="app-container">
    <list ref="list">
      <template #column>
        <el-table-column
          label="单据编号"
          prop="SourceNo"
          align="left"
          min-width="160"
          fixed="left"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="toPage(row)">{{ row.SourceNo }}</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/inventoryledger/list'


export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      api: require("@/api/stock/stInDoc").default,
      stOutDocApi: require("@/api/stock/stOutDoc").default,
    }
  },
  mounted() {
    if (!this.$permission.canPrice()) {
      const findIndex = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "收入");
      if (findIndex >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex].children.findIndex(item => item.tableName == "InBasePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex].children.findIndex(item => item.tableName == "InAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex].children.splice(i1, 1);
      }
      const findIndex1 = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "发出");
      if (findIndex1 >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex1].children.findIndex(item => item.tableName == "OutBasePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex1].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex1].children.findIndex(item => item.tableName == "OutAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex1].children.splice(i1, 1);
      }
      const findIndex2 = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "结存");
      if (findIndex2 >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex2].children.findIndex(item => item.tableName == "FinalAveragePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex2].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex2].children.findIndex(item => item.tableName == "FinalAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex2].children.splice(i1, 1);
      }
    }

  },
  methods: {
    toPage(row) {
      if (row.SourceTypeName == '生产入库单' || row.SourceTypeName == '其它入库单') {
        let id = row.SourceId;
        this.api.info(id).then(res => {
          if(res.Code === 0){
            this.$router.push({
              name: row.SourceTypeName == '生产入库单' ? 'editproductionshipping' : 'editotherinbound',
              params: {
                type: 'edit',
                data: res.Data
              }
            })
          }
          

        })
      } if (row.SourceTypeName == '销售出库单') {
        let id = row.SourceId;
        this.stOutDocApi.info(id).then(res => {
          if(res.Code === 0){
            this.$router.push({
              name: 'editselloutwarehouse',
              params: {
                type: 'edit',
                data: res.Data
              }
            })
          }else{
            this.$message({type: 'warning', message: res.Msg})
          }
        })
      } else {
        this.$message({type: 'warning', message: '暂时未实现该类型单据的详情跳转！'})
      }
    },
  }
};
</script>